import React from 'react';
import { VideoPlayButton } from './styled';

export default function PlayIcon({ allReviews, bannerVideo }) {
  return (
    <VideoPlayButton bannerVideo={bannerVideo} allReviews={allReviews}>
      <img src="/images/playiconvermilion.png" alt={'play_icon'} />
    </VideoPlayButton>
  );
}
